// AircraftTypes.js — SÜPER ADMIN: ORTAK UÇAK TİPİ LİSTESİ (30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl): *"Süper adminde tip list … öyle bir modül olsun, ADD TYPE olsun."* ·
//    *"Tip modülünde amaç şu: hem tipi double check, bir de tescili kontrol etmek … süper
//    adminde tip girişi GO2'nun yapacağı bir iş … kaynak FAA veya ICAO olacak, yoksa planla
//    tip uyuşmaz."*
// Adım 4a: LİSTE + ARAMA · adım 4c: ADD TYPE (kaynak FAA ya da ICAO, gerekçe + ekleyen zorunlu —
// veritabanı da aynısını ister, 20260930f). Tescil araması (4d) ayrı adım.
// Okuma ve arama AIRCRAFTS tip seçicisiyle AYNI kaynaktan: ../ucakTipleri.js.
// Liste şirkete ait değildir (küresel başvuru tablosu, `aircraft_types`). Adım T2 (Serkan: "tek tip method" ·
// "FAA'dan gelen liste edit edilmesin … locked olsun" · "bizim sonradan eklediklerimiz edit edilebilsin"):
// EDIT TYPE meydanla AYNI pencere — FAA satırı KİLİTLİ, GO2 satırı düzeltilir/WITHDRAWN; silme YOK (20260930j).
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { ucakTipleriniOku, tipAra, ELLE_KAYNAKLAR, MOTOR_SAYILARI, MOTOR_TURLERI, WTC_SINIFLARI,
         ELLE_SINIF, ICAO_TIP_ARAMA, tipFormHatasi, motorParcala, tipAlanlari, tipVeriAlanlari } from '../ucakTipleri';
import { ilkEksik, listedenAlan } from './tasarim';   // alan listesi kapısı + zorunlu alan rengi (5 Eki 2026)
import { RevizyonKurali, GecmisListesi, REVIZYON_EKSIK, gerekceliGuncelle } from './RevizyonUsulu';
// Harf kapısı (Serkan, 20 Eyl): uygulamanın hiçbir yerinde İngilizce dışında karakter girilmez.
import HarfliGiris from './HarfliGiris';
import { utcGun } from '../utcTarih';
import { SAYILI, hepsiniOku, okumaHataMetni } from './kesikOkuma';   // 24 ay şartı — kayıt geçmişi tam (6 Eki 2026)
import { GerekceIpucu, gerekceTamam, gerekceIpucuMetni } from './gerekce';   // ortak gerekçe kuralı + satırı (21 Eki 2026, K7)

const C = {
  bg2:'var(--bg2)', bg3:'var(--bg3)', border:'var(--border)',
  t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)', accent:'var(--accent)', red:'var(--red)',
};
const kutu = { width:'100%', boxSizing:'border-box', background:C.bg3, color:C.t1,
               border:`1px solid ${C.border}`, borderRadius:4, padding:'7px 9px',
               fontSize:12, fontFamily:'var(--mono)' };
const etiket = { display:'block', fontSize:9, color:C.t3, fontWeight:700,
                 letterSpacing:1, marginBottom:4 };
const th = { textAlign:'left', padding:'7px 10px', fontSize:9, color:C.t3, fontWeight:700,
             letterSpacing:1, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' };
const td = { padding:'7px 10px', fontSize:12, color:C.t1, borderBottom:`1px solid ${C.border}`,
             fontFamily:'var(--mono)', verticalAlign:'top' };

const SINIR = 50;

// FAA listesinden gelen satır mı, GO2'nun elle eklediği satır mı: kaynağa ek olarak
// EKLEYEN yazılıysa elle eklenmiştir (veritabanı kısıtı ikisini birlikte ister).
export const elleEklendiMi = t => !!t.added_by;

// Gösterim UTC (Serkan: "her zaman UTC takip edeceğiz") — tek kaynak ../utcTarih.js.
const tarih = utcGun;

function TipTablosu({ satirlar, adlar, testId, onAc }) {
  const ekleyen = id => adlar.hata ? `(name not read — ${adlar.hata})` : (adlar.harita[id] || id);
  return (
    <table style={{ width:'100%', borderCollapse:'collapse' }} data-testid={testId}>
      <thead><tr>{['ICAO CODE','MANUFACTURER','MODEL','CLASS','ENGINE','WTC','SOURCE'].map(h =>
        <th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{satirlar.map(t => (
        <tr key={`${t.designator}|${t.manufacturer}|${t.model}`}>
          <td style={{ ...td, fontWeight:700 }}>
            <button onClick={() => onAc(t.id)} data-testid={`tip-duzelt-ac-${t.id}`} title="Open this type"
                    style={{ background:'none', border:'none', padding:0, cursor:'pointer', color:C.accent,
                             fontWeight:700, fontFamily:'var(--mono)', fontSize:12, textDecoration:'underline' }}>
              {t.designator}</button></td>
          <td style={td}>{t.manufacturer}</td>
          <td style={td}>{t.model}
            {t.withdrawn_at && <span data-testid="tip-geri-cekildi-rozet" style={{ marginLeft:8, fontSize:9, fontWeight:700,
              letterSpacing:1, color:C.red, border:`1px solid ${C.red}`, borderRadius:3, padding:'1px 5px' }}>WITHDRAWN</span>}</td>
          <td style={td}>{t.aircraft_class || '—'}</td>
          <td style={td}>{t.engine || '—'}</td>
          <td style={td}>{t.icao_wtc || '—'}</td>
          <td style={td}>
            <div>{t.source}</div>
            {elleEklendiMi(t) && (
              <div style={{ fontSize:10, color:C.t3, marginTop:3, lineHeight:1.5 }}>
                added by {ekleyen(t.added_by)} · {tarih(t.created_at)}<br/>reason: {t.reason}
              </div>
            )}
          </td>
        </tr>
      ))}</tbody>
    </table>
  );
}

const BOS_FORM = { designator:'', manufacturer:'', model:'', motorSayi:'', motorTur:'', icao_wtc:'', source:'', reason:'' };

function TipEkleFormu({ tipler, myProfile, toast, onKaydedildi, onKapat }) {
  const [f, setF] = useState(BOS_FORM);
  const [kaydediyor, setKaydediyor] = useState(false);
  const alan = k => v => setF(p => ({ ...p, [k]: v }));
  // Aynı kod listede varsa o satırlar hemen gösterilir — aynı tip ikinci kez girilmesin.
  const ayniKod = f.designator.length >= 2 ? tipler.filter(t => t.designator === f.designator) : [];
  const hata = tipFormHatasi(f);
  // Zorunlu alan rengi — kapının AYNI listesinden (`tipAlanlari`), iPad kuralı (5 Eki 2026).
  const alanlar = tipAlanlari(f);
  const za = (a, taban = kutu) => listedenAlan(alanlar, a, taban);
  const kaydet = async () => {
    if (hata) { toast(hata, 'error'); return; }
    if (!myProfile?.id) { toast('Your profile could not be read — the type was not added.', 'error'); return; }
    setKaydediyor(true);
    const { error } = await supabase.from('aircraft_types').insert({
      designator: f.designator, manufacturer: f.manufacturer.trim(), model: f.model.trim(),
      aircraft_class: ELLE_SINIF, engine: f.motorSayi + f.motorTur, icao_wtc: f.icao_wtc,
      source: f.source, reason: f.reason.trim(), added_by: myProfile.id,
    });
    setKaydediyor(false);
    // Bildirim veritabanı hatasını okunur cümleye çevirir (dbHata).
    if (error) { toast(error.message, 'error'); return; }
    toast(`${f.designator} added to the aircraft type list.`, 'success');
    onKaydedildi();
  };
  const sec = (k, secenekler, bos, testId) => (
    <select {...za(k)} value={f[k]} data-testid={testId} onChange={e => alan(k)(e.target.value)}>
      <option value="">{bos}</option>
      {secenekler.map(o => Array.isArray(o)
        ? <option key={o[0]} value={o[0]}>{o[1]}</option>
        : <option key={o} value={o}>{o}</option>)}
    </select>
  );
  return (
    <div data-testid="tip-ekle-formu" style={{ border:`1px solid ${C.border}`, borderRadius:6, padding:14,
                                                marginBottom:18, maxWidth:640, background:C.bg2 }}>
      <div style={{ ...etiket, fontSize:10, color:C.accent }}>ADD TYPE</div>
      <div style={{ fontSize:10, color:C.t3, marginBottom:12, lineHeight:1.6 }}>
        Check the type in the ICAO list before adding it —{' '}
        <a href={ICAO_TIP_ARAMA} target="_blank" rel="noreferrer" data-testid="icao-baglanti"
           style={{ color:C.accent }}>ICAO Doc 8643 type designator search ↗</a>. The row is saved in your name
        with today's date. It is never deleted; later it can be corrected or withdrawn with a reason, after the
        change is announced in the monthly revision list.
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <div><label style={etiket}>ICAO TYPE CODE *</label>
          <HarfliGiris {...za('designator')} data-testid="tip-ekle-kod" placeholder="PC24" maxLength={4}
                       value={f.designator} onChange={alan('designator')} /></div>
        <div><label style={etiket}>CLASS</label>
          <div style={{ ...kutu, color:C.t3 }}>{ELLE_SINIF}</div></div>
        <div><label style={etiket}>MANUFACTURER *</label>
          <HarfliGiris {...za('manufacturer')} data-testid="tip-ekle-uretici" placeholder="PILATUS"
                       value={f.manufacturer} onChange={alan('manufacturer')} /></div>
        <div><label style={etiket}>MODEL *</label>
          <HarfliGiris {...za('model')} data-testid="tip-ekle-model" placeholder="PC-24"
                       value={f.model} onChange={alan('model')} /></div>
        <div><label style={etiket}>ENGINES *</label>
          <div style={{ display:'flex', gap:8 }}>
            {sec('motorSayi', MOTOR_SAYILARI, 'Number', 'tip-ekle-motor-sayi')}
            {sec('motorTur', MOTOR_TURLERI, 'Type', 'tip-ekle-motor-tur')}
          </div></div>
        <div><label style={etiket}>ICAO WTC *</label>{sec('icao_wtc', WTC_SINIFLARI, 'Choose', 'tip-ekle-wtc')}</div>
        <div><label style={etiket}>SOURCE *</label>{sec('source', ELLE_KAYNAKLAR, 'Choose', 'tip-ekle-kaynak')}</div>
      </div>
      <div style={{ marginTop:12 }}><label style={etiket}>REASON *</label>
        <HarfliGiris as="textarea" {...za('reason', { ...kutu, minHeight:56, resize:'vertical' })} data-testid="tip-ekle-gerekce"
                     placeholder="E.G. GO2DEMO FORM 01 OCT 2026 · ICAO DOC 8643: PC24 L2J M"
                     value={f.reason} onChange={alan('reason')} /><GerekceIpucu metin={f.reason} testid="tip-ekle-gerekce-ipucu" /></div>
      {ayniKod.length > 0 && (
        <div data-testid="tip-ekle-ayni-kod" style={{ marginTop:12, fontSize:11, color:C.t2, lineHeight:1.6 }}>
          <b>{f.designator}</b> is already in the list:
          {ayniKod.map(t => <div key={`${t.manufacturer}|${t.model}`}>· {t.manufacturer} — {t.model} ({t.source})</div>)}
        </div>
      )}
      <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14, alignItems:'center' }}>
        {hata && <span data-testid="tip-ekle-eksik" style={{ fontSize:10, color:C.t3, marginRight:'auto' }}>{hata}</span>}
        <button onClick={onKapat} style={{ ...kutu, width:'auto', cursor:'pointer' }}>CANCEL</button>
        <button onClick={kaydet} disabled={kaydediyor} data-testid="tip-ekle-kaydet"
                style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                         color:'#08131f', background:C.accent, border:'none', borderRadius:4, fontFamily:'var(--mono)' }}>
          {kaydediyor ? 'SAVING…' : 'ADD TYPE'}
        </button>
      </div>
    </div>
  );
}

// ── EDIT TYPE (adım T2) — meydan düzeltmesiyle AYNI yöntem ────────────────────
// FAA satırı (added_by boş) KİLİTLİ: pencere açılır, alanlar salt okunur, değişiklik düğmesi YOK (veritabanı da
// reddeder, 20260930j). GO2 satırı: üretici, model, motor, WTC, kaynak düzeltilir; tip kodu DEĞİŞMEZ (uçaklar ve
// pilot yetkileri ona bağlı); WITHDRAW/RESTORE; gerekçe + aylık revizyon onayı + iz (HISTORY).

/** Değişen alanlar — yalnız bunlar gönderilir. */
export function tipDegisiklikleri(f, k) {
  const d = {};
  if (f.manufacturer.trim() !== (k.manufacturer || '')) d.manufacturer = f.manufacturer.trim();
  if (f.model.trim() !== (k.model || '')) d.model = f.model.trim();
  const motor = f.motorSayi + f.motorTur;
  if (motor !== (k.engine || '')) d.engine = motor;
  if (f.icao_wtc !== (k.icao_wtc || '')) d.icao_wtc = f.icao_wtc;
  if (f.source !== (k.source || '')) d.source = f.source;
  return d;
}

/** Düzeltmenin eksiği; yoksa null. */
export function tipDuzeltmeHatasi(f, k) {
  if (!Object.keys(tipDegisiklikleri(f, k)).length) return 'Nothing changed.';
  return ilkEksik(tipVeriAlanlari(f));   // ekleme formuyla AYNI alan listesi (kod hariç — kod düzeltilmez)
}

function TipDuzeltFormu({ id, toast, onKaydedildi, onKapat }) {
  const [kayit, setKayit] = useState({ satir: null, hata: null, yuklendi: false });
  const [iz, setIz] = useState({ satirlar: [], hata: null });
  const [adlar, setAdlar] = useState({});
  const [adHata, setAdHata] = useState(null);
  const [f, setF] = useState(null);
  const [revizyon, setRevizyon] = useState(false);
  const [kaydediyor, setKaydediyor] = useState(false);

  useEffect(() => {
    let iptal = false;
    (async () => {
      const [{ data, error }, izr] = await Promise.all([
        supabase.from('aircraft_types').select('*').eq('id', id).maybeSingle(),
        // Kayıt geçmişi TAM (6 Eki 2026, 24 ay şartı 2d-2b): koda gömülü son 50 kalktı, parça parça; kesik okuma
        // "HISTORY NOT READ" olur (yarım geçmiş gösterilmez — Serkan A).
        hepsiniOku(() => supabase.from('superadmin_log').select('id,at,actor_id,op,field,old_value,new_value,reason', SAYILI)
          .eq('table_name', 'aircraft_types').eq('row_id', id).order('at', { ascending: false })),
      ]);
      if (iptal) return;
      setKayit({ satir: data || null, hata: error ? error.message : (data ? null : 'this type was not found'), yuklendi: true });
      const izHata = okumaHataMetni(izr);
      setIz({ satirlar: izHata ? [] : (izr.data || []), hata: izHata });
      if (data) setF({ manufacturer: data.manufacturer || '', model: data.model || '', ...motorParcala(data.engine),
                       icao_wtc: data.icao_wtc || '', source: data.source || '', reason: '' });
      const idler = [...new Set([data?.added_by, data?.withdrawn_by, ...(izr.data || []).map(r => r.actor_id)].filter(Boolean))];
      if (!idler.length) return;
      const { data: p, error: pErr } = await supabase.from('profiles').select('id,code,full_name').in('id', idler);
      if (iptal) return;
      // 21 Eki 2026 (W4b): ad okunamazsa söylenir (listedeki `ekleyen` ile aynı desen).
      setAdHata(pErr ? (pErr.message || String(pErr)) : null);
      const h = {}; (p || []).forEach(x => { h[x.id] = [x.code, x.full_name].filter(Boolean).join(' — '); });
      setAdlar(h);
    })();
    return () => { iptal = true; };
  }, [id]);

  if (!kayit.yuklendi) return <div style={{ fontSize:10, color:C.t3, marginBottom:14 }}>LOADING TYPE…</div>;
  if (kayit.hata) return <div data-testid="tip-duzelt-hata" style={{ fontSize:12, color:C.red, fontWeight:700, marginBottom:14 }}>
    TYPE NOT READ — {kayit.hata}</div>;

  const k = kayit.satir;
  const faa = !elleEklendiMi(k);
  const geriCekildi = !!k.withdrawn_at;
  const kim = x => (x ? (adHata ? `(name not read — ${adHata})` : (adlar[x] || x)) : '—');
  const alan = a => v => setF(p => ({ ...p, [a]: v }));
  const hata = tipDuzeltmeHatasi(f, k);
  const eksik = hata || (!revizyon ? REVIZYON_EKSIK : null);
  const yaz = async (degisiklik, basari) => {
    setKaydediyor(true);
    const { hata: yazmaHatasi } = await gerekceliGuncelle({ tablo: 'aircraft_types', anahtarKolon: 'id', anahtar: id,
      etiket: `${k.designator} (${k.model})`, degisiklik, gerekce: f.reason });
    setKaydediyor(false);
    if (yazmaHatasi) { toast(yazmaHatasi, 'error'); return; }
    toast(basari, 'success');
    onKaydedildi();
  };
  const kaydet = () => { if (eksik) { toast(eksik, 'error'); return; } yaz(tipDegisiklikleri(f, k), `${k.designator} corrected.`); };
  const geriCekAc = () => {
    if (!gerekceTamam(f.reason)) { toast(gerekceIpucuMetni(f.reason), 'error'); return; }
    if (!revizyon) { toast(REVIZYON_EKSIK, 'error'); return; }
    const soru = geriCekildi
      ? `Restore ${k.designator} (${k.model})? It can be chosen again for aircraft and type ratings.`
      : `Withdraw ${k.designator} (${k.model})? It can no longer be chosen for a new aircraft or type rating; aircraft and ratings that already use it are not affected.`;
    if (!window.confirm(soru)) return;
    // Geri çekme anı, çeken ve gerekçe TETİKLEYİCİDE yazılır; buradaki zaman yalnız "geri çek" işaretidir.
    yaz({ withdrawn_at: geriCekildi ? null : new Date().toISOString() },
        geriCekildi ? `${k.designator} restored.` : `${k.designator} withdrawn.`);
  };
  // Zorunlu alan rengi — kapının AYNI listesinden (`tipVeriAlanlari`); FAA satırı kilitli, düzenlenmez → renk yok.
  const alanlarD = faa ? [] : tipVeriAlanlari(f);
  const zd = (a, taban = kutu) => listedenAlan(alanlarD, a, taban);
  const sec = (a, secenekler, bos, testId) => (
    <select {...zd(a)} value={f[a]} data-testid={testId} disabled={faa} onChange={e => alan(a)(e.target.value)}>
      <option value="">{bos}</option>
      {secenekler.map(o => Array.isArray(o)
        ? <option key={o[0]} value={o[0]}>{o[1]}</option>
        : <option key={o} value={o}>{o}</option>)}
      {/* FAA satırının kaynağı ('FAA JO 7360.1K') elle ekleme listesinde yoksa bile görünsün. */}
      {f[a] && !secenekler.some(o => (Array.isArray(o) ? o[0] : o) === f[a]) && <option value={f[a]}>{f[a]}</option>}
    </select>
  );

  return (
    <div data-testid="tip-duzelt-formu" style={{ border:`1px solid ${C.border}`, borderRadius:6, padding:14,
                                                  marginBottom:18, maxWidth:680, background:C.bg2 }}>
      <div style={{ ...etiket, fontSize:10, color:C.accent }}>{faa ? 'TYPE' : 'EDIT TYPE'} — {k.designator}</div>
      <div data-testid="tip-duzelt-kunye" style={{ fontSize:10, color:C.t3, marginBottom:12, lineHeight:1.7 }}>
        Type code {k.designator} cannot be changed — aircraft and type ratings are linked to it. Source: {k.source}
        {!faa && <> · added by {kim(k.added_by)} · {tarih(k.created_at)} · reason: {k.reason}</>}
        {geriCekildi && <div data-testid="tip-duzelt-geri-cekildi" style={{ color:C.red, fontWeight:700 }}>
          WITHDRAWN since {tarih(k.withdrawn_at)} by {kim(k.withdrawn_by)} — {k.withdrawn_reason}</div>}
      </div>
      {faa
        ? <div data-testid="tip-duzelt-kilitli" style={{ fontSize:11, color:C.red, fontWeight:700, marginBottom:12 }}>
            LOCKED — this type comes from the FAA list and cannot be changed here. Only types added by GO2 are corrected
            or withdrawn.</div>
        : <RevizyonKurali onay={revizyon} setOnay={setRevizyon} testId="tip-duzelt-revizyon" />}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
        <div><label style={etiket}>MANUFACTURER *</label>
          <HarfliGiris {...zd('manufacturer')} data-testid="tip-duzelt-uretici" value={f.manufacturer} readOnly={faa} disabled={faa}
                       onChange={alan('manufacturer')} /></div>
        <div><label style={etiket}>MODEL *</label>
          <HarfliGiris {...zd('model')} data-testid="tip-duzelt-model" value={f.model} readOnly={faa} disabled={faa}
                       onChange={alan('model')} /></div>
        <div><label style={etiket}>ENGINES *</label>
          <div style={{ display:'flex', gap:8 }}>
            {sec('motorSayi', MOTOR_SAYILARI, 'Number', 'tip-duzelt-motor-sayi')}
            {sec('motorTur', MOTOR_TURLERI, 'Type', 'tip-duzelt-motor-tur')}
          </div></div>
        <div><label style={etiket}>ICAO WTC *</label>{sec('icao_wtc', WTC_SINIFLARI, 'Choose', 'tip-duzelt-wtc')}</div>
        <div><label style={etiket}>SOURCE *</label>{sec('source', ELLE_KAYNAKLAR, 'Choose', 'tip-duzelt-kaynak')}</div>
        <div><label style={etiket}>CLASS</label><div style={{ ...kutu, color:C.t3 }}>{k.aircraft_class || '—'}</div></div>
      </div>
      {!faa && (
        <div style={{ marginTop:12 }}><label style={etiket}>REASON * (for a correction, a withdrawal or a restore)</label>
          <HarfliGiris as="textarea" {...zd('reason', { ...kutu, minHeight:56, resize:'vertical' })} data-testid="tip-duzelt-gerekce"
                       placeholder="E.G. REV 2026-10 · WRONG MODEL NAME" value={f.reason} onChange={alan('reason')} /><GerekceIpucu metin={f.reason} testid="tip-duzelt-gerekce-ipucu" /></div>
      )}
      <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:14, alignItems:'center' }}>
        {!faa && eksik && <span data-testid="tip-duzelt-eksik" style={{ fontSize:10, color:C.t3, marginRight:'auto' }}>{eksik}</span>}
        {!faa && (
          <button onClick={geriCekAc} disabled={kaydediyor} data-testid="tip-duzelt-geri-cek"
                  style={{ ...kutu, width:'auto', cursor:'pointer', color: geriCekildi ? C.accent : C.red,
                           borderColor: geriCekildi ? C.accent : C.red }}>
            {geriCekildi ? 'RESTORE TYPE' : 'WITHDRAW TYPE'}</button>)}
        <button onClick={onKapat} data-testid="tip-duzelt-kapat" style={{ ...kutu, width:'auto', cursor:'pointer' }}>
          {faa ? 'CLOSE' : 'CANCEL'}</button>
        {!faa && (
          <button onClick={kaydet} disabled={kaydediyor} data-testid="tip-duzelt-kaydet"
                  style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                           color:'#08131f', background:C.accent, border:'none', borderRadius:4, fontFamily:'var(--mono)' }}>
            {kaydediyor ? 'SAVING…' : 'SAVE CHANGES'}</button>)}
      </div>

      <div style={{ ...etiket, marginTop:18 }}>HISTORY</div>
      <GecmisListesi satirlar={iz.satirlar} hata={iz.hata} kim={kim} testId="tip-duzelt-iz"
                     bosMetni={faa ? 'No changes — the row is as it came from the FAA list.' : 'No changes recorded since it was added.'} />
    </div>
  );
}

export default function AircraftTypes({ toast = () => {}, myProfile = null }) {
  const [liste, setListe] = useState({ tipler: [], hata: null, yuklendi: false });
  const [adlar, setAdlar] = useState({ harita: {}, hata: null });
  const [sorgu, setSorgu] = useState('');
  const [ekle, setEkle] = useState(false);
  const [duzelt, setDuzelt] = useState(null);

  const yukle = useCallback(async (iptalMi = () => false) => {
    const r = await ucakTipleriniOku();
    if (iptalMi()) return;
    setListe({ ...r, yuklendi: true });
    // Elle eklenen satırın EKLEYENİ adıyla gösterilir; okunamazsa kimlik saklanmaz,
    // okunamadığı söylenir (İlke 1).
    const idler = [...new Set(r.tipler.filter(elleEklendiMi).map(t => t.added_by))];
    if (!idler.length) return;
    const { data, error } = await supabase.from('profiles').select('id,full_name,code').in('id', idler);
    if (iptalMi()) return;
    if (error) { setAdlar({ harita: {}, hata: error.message }); return; }
    const harita = {};
    (data || []).forEach(p => { harita[p.id] = [p.code, p.full_name].filter(Boolean).join(' — '); });
    setAdlar({ harita, hata: null });
  }, []);

  useEffect(() => {
    let iptal = false;
    yukle(() => iptal);
    return () => { iptal = true; };
  }, [yukle]);

  const { tipler, hata, yuklendi } = liste;
  const kodSayisi = new Set(tipler.map(t => t.designator)).size;
  const elle = tipler.filter(elleEklendiMi);
  const geriCekilen = tipler.filter(t => t.withdrawn_at).length;
  const sonuc = tipAra(tipler, sorgu, SINIR);
  const ac = tid => { setEkle(false); setDuzelt(tid); };

  return (
    <div style={{ flex:1, overflowY:'auto', padding:18, minWidth:0 }}>
      {!yuklendi && <div style={{ fontSize:10, color:C.t3 }}>LOADING...</div>}
      {yuklendi && hata && (
        <div data-testid="tip-listesi-hata" style={{ fontSize:12, color:C.red, fontWeight:700 }}>
          TYPE LIST NOT READ — {hata}
        </div>
      )}
      {yuklendi && !hata && (
        <>
          {duzelt
            ? <TipDuzeltFormu key={duzelt} id={duzelt} toast={toast} onKapat={() => setDuzelt(null)}
                              onKaydedildi={() => { setDuzelt(null); yukle(); }} />
            : ekle
            ? <TipEkleFormu tipler={tipler} myProfile={myProfile} toast={toast}
                            onKaydedildi={() => { setEkle(false); yukle(); }} onKapat={() => setEkle(false)} />
            : <button onClick={() => setEkle(true)} data-testid="tip-ekle"
                      style={{ padding:'8px 14px', fontSize:10, fontWeight:700, letterSpacing:1, cursor:'pointer',
                               color:'#08131f', background:C.accent, border:'none', borderRadius:4,
                               fontFamily:'var(--mono)', marginBottom:14 }}>+ ADD TYPE</button>}
          <div data-testid="tip-listesi-ozet" style={{ fontSize:11, color:C.t2, marginBottom:14, lineHeight:1.7 }}>
            {tipler.length} types · {kodSayisi} ICAO type codes · {tipler.length - elle.length} from
            the FAA list · {elle.length} added by GO2 · {geriCekilen} withdrawn
            <div style={{ fontSize:10, color:C.t3 }}>
              One shared list for every company. AIRCRAFTS chooses the aircraft type from it and a pilot's
              type rating is chosen from the company's aircraft types, so the type is written exactly as in
              the ATC flight plan (item 9).
            </div>
          </div>

          <label style={etiket}>SEARCH</label>
          <HarfliGiris style={{ ...kutu, maxWidth:420 }} data-testid="tip-listesi-arama" value={sorgu}
                       placeholder="G450, Falcon 7X, Citation, GLF4 …" onChange={setSorgu} />
          <div style={{ marginTop:12 }}>
            {sorgu.trim().length < 2
              ? <div style={{ fontSize:10, color:C.t3 }}>Type at least 2 characters.</div>
              : sonuc.length === 0
              ? <div data-testid="tip-listesi-yok" style={{ fontSize:11, color:C.t2 }}>No type matches “{sorgu}”.</div>
              : <>
                  <TipTablosu satirlar={sonuc.slice(0, SINIR)} adlar={adlar} testId="tip-listesi-sonuc" onAc={ac} />
                  {sonuc.length > SINIR && (
                    <div data-testid="tip-listesi-fazla" style={{ fontSize:10, color:C.t3, marginTop:6 }}>
                      More than {SINIR} matches — refine the search.
                    </div>
                  )}
                </>}
          </div>

          <div style={{ ...etiket, marginTop:24 }}>ADDED BY GO2</div>
          {elle.length === 0
            ? <div data-testid="tip-listesi-elle-yok" style={{ fontSize:10, color:C.t3 }}>None yet — every type comes from the FAA list.</div>
            : <TipTablosu satirlar={elle} adlar={adlar} testId="tip-listesi-elle" onAc={ac} />}
        </>
      )}
    </div>
  );
}
